import { Action } from 'redux';

import {
    APIFailureAction,
    APIRequestAction,
    APISuccessAction,
} from 'mk2/helpers/action';

// API
// Mail delete
export interface MailDeleteApiAction extends Action {
    readonly ids: number[];
    readonly undoId: string;
}

export const MAIL_DELETE_API_REQUEST = 'MAIL_DELETE_API_REQUEST';
export interface MailDeleteApiRequestAction extends MailDeleteApiAction, APIRequestAction {
    readonly type: typeof MAIL_DELETE_API_REQUEST;
}

export const MAIL_DELETE_API_SUCCESS = 'MAIL_DELETE_API_SUCCESS';
export interface MailDeleteApiSuccessAction extends MailDeleteApiAction, APISuccessAction {
    readonly type: typeof MAIL_DELETE_API_SUCCESS;
}

export const MAIL_DELETE_API_FAILURE = 'MAIL_DELETE_API_FAILURE';
export interface MailDeleteApiFailureAction extends MailDeleteApiAction, APIFailureAction {
    readonly type: typeof MAIL_DELETE_API_FAILURE;
}

export const mailDeleteApi = {
    request: (ids: number[], undoId: string): MailDeleteApiRequestAction => ({ type: MAIL_DELETE_API_REQUEST, ids, undoId }),
    success: (ids: number[], undoId: string, response: any): MailDeleteApiSuccessAction => ({ type: MAIL_DELETE_API_SUCCESS, ids, undoId, response }),
    failure: (ids: number[], undoId: string, error: any): MailDeleteApiFailureAction => ({ type: MAIL_DELETE_API_FAILURE, ids, undoId, error }),
};

export interface MailUndeleteApiAction extends MailDeleteApiAction {
}

export const MAIL_UNDELETE_API_REQUEST = 'MAIL_UNDELETE_API_REQUEST';

export interface MailUndeleteApiRequestAction extends MailUndeleteApiAction, APIRequestAction {
    readonly type: typeof MAIL_UNDELETE_API_REQUEST;
}

export const MAIL_UNDELETE_API_SUCCESS = 'MAIL_UNDELETE_API_SUCCESS';

export interface MailUndeleteApiSuccessAction extends MailUndeleteApiAction, APISuccessAction {
    readonly type: typeof MAIL_UNDELETE_API_SUCCESS;
}

export const MAIL_UNDELETE_API_FAILURE = 'MAIL_UNDELETE_API_FAILURE';

export interface MailUndeleteApiFailureAction extends MailUndeleteApiAction, APIFailureAction {
    readonly type: typeof MAIL_UNDELETE_API_FAILURE;
}

export const mailUndeleteApi = {
    request: (ids: number[], undoId: string): MailUndeleteApiRequestAction => ({ type: MAIL_UNDELETE_API_REQUEST, ids, undoId }),
    success: (ids: number[], undoId: string, response: any): MailUndeleteApiSuccessAction => ({ type: MAIL_UNDELETE_API_SUCCESS, ids, undoId, response }),
    failure: (ids: number[], undoId: string, error: any): MailUndeleteApiFailureAction => ({ type: MAIL_UNDELETE_API_FAILURE, ids, undoId, error }),
};

// Mail report
export interface MailReportApiAction extends Action {
    readonly id: number;
}

export const MAIL_REPORT_API_REQUEST = 'MAIL_REPORT_SAVE_REQUEST';
export interface MailReportApiRequestAction extends MailReportApiAction, APIRequestAction {
    readonly type: typeof MAIL_REPORT_API_REQUEST;
}

export const MAIL_REPORT_API_SUCCESS = 'MAIL_REPORT_SAVE_SUCCESS';
export interface MailReportApiSuccessAction extends MailReportApiAction, APISuccessAction {
    readonly type: typeof MAIL_REPORT_API_SUCCESS;
    readonly undoId: string;
}

export const MAIL_REPORT_API_FAILURE = 'MAIL_REPORT_SAVE_FAILURE';
export interface MailReportApiFailureAction extends MailReportApiAction, APIFailureAction {
    readonly type: typeof MAIL_REPORT_API_FAILURE;
    readonly undoId: string;
}

export const mailReportApi = {
    request: (id: number): MailReportApiRequestAction => ({ type: MAIL_REPORT_API_REQUEST, id }),
    success: (id: number, undoId: string, response: any): MailReportApiSuccessAction => ({ type: MAIL_REPORT_API_SUCCESS, id, undoId, response }),
    failure: (id: number, undoId: string, error: any): MailReportApiFailureAction => ({ type: MAIL_REPORT_API_FAILURE, id, undoId, error }),
};

// Triggers
// Mail delete
export const MAIL_DELETE = 'MAIL_DELETE';

export interface MailDeleteAction extends Action {
    readonly ids: number[];
    readonly type: typeof MAIL_DELETE;
}

export const mailDelete = (ids: number[]): MailDeleteAction => ({
    type: MAIL_DELETE, ids,
});

// Mail remove from lists
export const MAIL_DELETE_OPTIMISTIC = 'MAIL_DELETE_OPTIMISTIC';

export interface MailDeleteOptimisticAction extends MailDeleteApiAction {
    readonly type: typeof MAIL_DELETE_OPTIMISTIC;
}

export const mailDeleteOptimistic = (ids: number[], undoId: string): MailDeleteOptimisticAction => ({
    type: MAIL_DELETE_OPTIMISTIC, ids, undoId,
});

export const MAIL_DELETE_COMMIT = 'MAIL_DELETE_COMMIT';

export interface MailDeleteCommitAction extends Action {
    readonly type: typeof MAIL_DELETE_COMMIT;
    readonly undoId: string;
}

export const mailDeleteCommit = (undoId: string): MailDeleteCommitAction => ({ type: MAIL_DELETE_COMMIT, undoId });

// Mail delete undo
export const MAIL_DELETE_UNDO = 'MAIL_DELETE_UNDO';

export interface MailDeleteUndoAction {
    readonly type: typeof MAIL_DELETE_UNDO;
    readonly undoId: string;
}

export const mailDeleteUndo = (undoId: string): MailDeleteUndoAction => ({
    type: MAIL_DELETE_UNDO, undoId,
});

// Mail report
export const MAIL_REPORT = 'MAIL_REPORT';

export interface MailReportAction extends MailReportApiAction {
    readonly type: typeof MAIL_REPORT;
}

export const mailReport = (id: number): MailReportAction => ({
    type: MAIL_REPORT, id,
});
